import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Flags } from "./models/flags";
import { ADMIN_GROUP, ENGINEER_GROUP, UserGroup } from "../utils/group";

export interface FlashPCBAuth {
  loading: boolean;
  signedIn: boolean;
  email: string | null;
  sub: string | null;
  userId: string | null;
  groups: UserGroup[];
  flags: Flags;
  isAdminOrEngineer: boolean;
}

export const authSlice = createSlice({
  name: "auth",
  initialState: {
    loading: true,
    signedIn: false,
    email: null,
    sub: null,
    userId: null,
    groups: [],
    flags: {},
    isAdminOrEngineer: false,
  } as FlashPCBAuth,
  reducers: {
    authLoaded: (
      state,
      action: PayloadAction<{
        signedIn: boolean;
        email: string;
        sub: string;
        userId: string;
        groups: UserGroup[];
        flags: Flags;
      }>,
    ) => {
      state.signedIn = action.payload.signedIn;
      state.groups = action.payload.groups;
      state.email = action.payload.email;
      state.sub = action.payload.sub;
      state.userId = action.payload.userId;
      state.loading = false;
      state.flags = action.payload.flags;
      state.isAdminOrEngineer =
        state.groups.includes(ADMIN_GROUP) ||
        state.groups.includes(ENGINEER_GROUP);
    },
    signOut: (state) => {
      state.loading = false;
      state.signedIn = false;
      state.email = null;
      state.sub = null;
      state.userId = null;
      state.groups = [];
      state.flags = {};
      state.isAdminOrEngineer = false;
    },
  },
});

export const { signOut, authLoaded } = authSlice.actions;

export default authSlice.reducer;
